import React from 'react';
import PropTypes from 'prop-types';
import Check from 'images/icons/check.svg';
import style from './style.scss'; //NOSONAR

const RadioButton = (props) => {

    const { item, name, callbackSelect, value } = props;

    return(
        <div className="radio-button-container-input">
            <span className={'check-radio-button' + ((item ) ?  ' check': '')} dangerouslySetInnerHTML={{ __html: Check }}></span>
            <input type='radio' className={'input-radio-button' + ((item) ?  ' check': '')} value={value ? value : ''} name={name} defaultChecked={(item) ? ' checked' : ''} onClick={event => {(callbackSelect ? callbackSelect(event) : () => {})}} />
        </div>
    )
}

RadioButton.propTypes = {
    item: PropTypes.bool,
    name: PropTypes.string,
    callbackSelect: PropTypes.func,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

export default RadioButton;
